import { BitmapLayer } from '@deck.gl/layers';
import { TileLayer } from '@deck.gl/geo-layers';
import * as layerOps from '../../api/Layers/layer-operations';

const buildDeckTileLayer = ({ layer, FindLayerVisible, activeLayers }) => {
  return new TileLayer({
    id: layerOps.getId(layer),
    data: layerOps.getURL(layer),
    minZoom: layerOps.getMinZoom(layer),
    maxZoom: layerOps.getMaxZoom(layer),
    tileSize: 256,
    visible: FindLayerVisible(layerOps.getId(layer)),
    updateTriggers: {
      visible: [activeLayers]
    },
    // eslint-disable-next-line no-shadow
    renderSubLayers: props => {
      const {
        // eslint-disable-next-line react/prop-types
        bbox: { west, south, east, north }
        // eslint-disable-next-line react/prop-types
      } = props.tile;

      return new BitmapLayer(props, {
        data: null,
        // eslint-disable-next-line react/prop-types
        image: props.data,
        bounds: [west, south, east, north]
      });
    }
  });
};

export default buildDeckTileLayer;
